export default __webpack_public_path__ + "static/media/add_purple.780f75f7.svg";